export const DocstoreSections = {
  PERMITS: "Разрешительная документация",
  WORKING_DRAFT: "Проектная документация",
  WORK: "Рабочая документация",
  EXECUTIVE_SCHEME: "Исполнительные схемы",
  EXECUTIVE_DRAWING: "Исполнительные чертежи",
  CERTIFICATE: "Документы подтверждающие качество",
  LABORATORY_DATA: "Лаборатории",
  SUPPORTING: "Сопроводительные документы",
  NORMATIVE: "Нормативная документация",
  TRASH: "Корзина",
};

export const sections = Object.keys(
  DocstoreSections,
) as (keyof typeof DocstoreSections)[];

export const sectionsValues = Object.values(DocstoreSections).filter(
  (section) => section !== DocstoreSections.TRASH,
);
